import { useToast } from '#app/components/Toasts/hooks/useToast.js';
import { readFile } from '#app/services/file.js';
import { ALLOWED_FILE_TYPES } from './constants.js';
import { ProfileImageCropperContext } from './context/ProfileImageCropperContext.js';
import { type ChangeEvent, forwardRef, type Ref, useContext } from 'react';

const ALLOWED_TYPES_ARRAY = ALLOWED_FILE_TYPES.join(',');

export const ProfileImageCropperUploadInput = forwardRef(
  ({ id }: { readonly id: string }, ref: Ref<HTMLInputElement>) => {
    const { startCropping } = useContext(ProfileImageCropperContext);
    const toast = useToast();

    const onChange = async (event: ChangeEvent<HTMLInputElement>) => {
      const file = event?.currentTarget?.files?.[0];

      if (!file) {
        return;
      }

      event.target.value = '';

      // Chris found a way to break MacOS and forcibly upload non-allowed filetypes so, because of that, we have to have this
      // fix here so we can all thank Chris for breaking his Mac. -@lmulvey
      const validType = ALLOWED_TYPES_ARRAY.includes(file.type);
      const imageDataURL = await readFile(file);

      if (imageDataURL && validType) {
        startCropping({
          imageDataURL,
          imageFile: file,
          imageName: file.name,
          imageType: file.type,
        });
      } else {
        toast.error('Invalid file type. Please try again!');
      }
    };

    return (
      <input
        accept={ALLOWED_TYPES_ARRAY}
        aria-labelledby="uploadButton"
        data-testid="profileImageUpload"
        id={id}
        onChange={onChange}
        ref={ref}
        style={{ display: 'none' }}
        type="file"
      />
    );
  },
);
